<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'components.deleteClient.title' | translate }}
    </h4>
    <button class="btn-close" (click)="d('Cross click')" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isLoading"></app-spinner>
      </div>
    } @else if (isDeletionBlocked) {
      <p class="block-notice">{{ blockReasonKey | translate }}</p>
    } @else {
      <form [formGroup]="form">
        <div class="mb-3">
          <label class="form-label lna" for="name">
            {{ 'components.deleteClient.deleteReason' | translate }}
            <span class="required-field">*</span>
          </label>
          <textarea
            class="form-control lna"
            [ngClass]="{
              invalid: this.shouldRenderError('deleteReason') && deleteReason?.errors
            }"
            rows="5"
            type="text"
            formControlName="deleteReason"
            placeholder="{{ 'components.deleteClient.deleteReasonPlaceholder' | translate }}"></textarea>
          @if (this.shouldRenderError('deleteReason') && deleteReason?.errors) {
            @if (deleteReason?.errors?.['required']) {
              <small class="error-message">
                {{ 'components.form.errorRequired' | translate }}
              </small>
            } @else if (deleteReason?.errors?.['maxlength']) {
              <small class="error-message">
                {{
                  'components.form.maxLength'
                    | translate
                      : {
                          maxLength: deleteReason?.errors?.['maxlength']['requiredLength']
                        }
                }}
              </small>
            }
          }
        </div>
      </form>
    }
  </div>
  <div class="lna-modal-footer">
    @if (!isDeletionBlocked) {
      <button class="primary" [disabled]="isLoading" (click)="handleSave()" type="button">
        {{ 'components.deleteClient.submit' | translate }}
      </button>
    }
    <button class="secondary" (click)="d('Cross click')" type="button">
      {{ (isDeletionBlocked ? 'components.deleteClient.close' : 'components.deleteClient.cancel') | translate }}
    </button>
  </div>
</ng-template>

<button class="delete-user link-btn" (click)="open(content)">
  <img [attr.alt]="'imgAlt.deleteIcon' | translate" src="assets/images/delete-icon.svg" />
  {{ 'pages.client.activities.deleteClient' | translate }}
</button>

<app-confirm-modal
  [isOpen]="isConfirmModalOpen"
  (confirm)="deleteClient(true)"
  (cancel)="isConfirmModalOpen = false"
  title="deleteClient"
  body="deleteClientBodyText" />
